export const focusedNewMessagesRollupText = "Cngzje";
export const otherNewMessagesRollupText = "J9YPXb";
export const focusedRollupText = "OEw5oc";
export const otherRollupText = "X27Igd";
export default {focusedNewMessagesRollupText,otherNewMessagesRollupText,focusedRollupText,otherRollupText};